import Carousel from 'react-bootstrap/Carousel';
import { Container, Col, Row, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
// import {CarouselCaption} from "react-bootstrap/Carousel";
import React from "react";
import testimonialsPicture1 from "./img/testimonial-1.jpeg";
import testimonialsPicture2 from "./img/testimonial-2.jpeg";
import testimonialsPicture3 from "./img/testimonial-3.jpg";
import sliderCSS from "./css/slider.css";
import { useTranslation } from 'react-i18next';

export const TestimonialsSlider = () => {
  const { t } = useTranslation();

  


  return (
    <Container>
      <Row>
        <Col >
          {/* <Carousel className="w-100 m-auto"> */}

          {/* <Carousel.Item> */}
          <div className='review-1'>
            
              <Image className="testim-image" alt={t("testimonialsSliderImageAlt")}
                src={testimonialsPicture2} roundedCircle circular text="Second slide" />
              {/* <Carousel.Caption className="carousel-caption testim-caption"> */}
              <div className='review-1-text'>
              <h3
              className="carousel-heading testim-heading testim-heading-1"
              >
                {t("testimonial1")}</h3>
              <cite className="testim-text-1 testimonials-cite">{t("testimonial1Text")}<Link title={t("testimonialSliderMore")} className="pl-2 text-white testim-more more" target="_blank" to="https://www.linkedin.com/in/yevheniiairapetian/" >{t("testimonialsMore")}</Link>
              </cite>
            </div>
          </div>
          {/* </Carousel.Caption> */}
          {/* </Carousel.Item> */}
          {/* <Carousel.Item> */}
          <div className='review-2'>

            <Image className="testim-image" alt={t("testimonialsSliderImageAlt")}
              src={testimonialsPicture1} roundedCircle text="First slide" />
              <div className='review-2-text'>

            {/* <Carousel.Caption className="carousel-caption testim-caption"> */}
            <h3 className="carousel-heading testim-heading testim-heading-2">{t("testimonial2")}</h3>
            <cite className="testim-text-2 testimonials-cite">{t("testimonial2Text")}
              <Link title={t("testimonialSliderMore")} className="pl-2 text-white testim-more more" target="_blank" to="https://www.linkedin.com/in/yevheniiairapetian/" >{t("testimonialsMore")}</Link>
            </cite>
            </div>
          </div>
          {/* </Carousel.Caption> */}
          {/* </Carousel.Item> */}
          {/* <Carousel.Item> */}
          <div className='review-3'>

            <Image className="testim-image" alt={t("testimonialsSliderImageAlt")}
              src={testimonialsPicture3} roundedCircle text="Third slide" />
            {/* <Carousel.Caption className="carousel-caption testim-caption"> */}
            <div className='review-3-text'>
            <h3 className="carousel-heading testim-heading testim-heading-3">{t("testimonial3")}</h3>
            <cite className="testim-text-3 testimonials-cite">{t("testimonial3Text")}

              <Link title={t("testimonialSliderMore")} className="pl-2 text-white testim-more more" target="_blank" to="https://www.linkedin.com/in/yevheniiairapetian/" >{t("testimonialsMore")}</Link>
            </cite>
            {/* </Carousel.Caption> */}
            {/* </Carousel.Item> */}
            </div>
          </div>

          {/* </Carousel> */}
        </Col>
      </Row>
    </Container>

  );
}
